import httpClient from '../httpClient';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import { PaginatedData } from 'models/PaginatedData';
import { Params } from 'react-router-dom';
import {
  DataRoomFaqAccessGranularityData,
  FAQAccessInfo,
} from '../../models/FAQ';

function getFaqs(dataRoomId: string, params: Params) {
  return httpClient.get<PaginatedData<Question>>(
    `data-room-questions/faqs/data-rooms/${dataRoomId}`,
    {
      params,
    },
  );
}

type CreateFaqValues = {
  subject?: string;
  content?: string;
  answerContent?: string;
  isPublishedToFAQ?: boolean;
};

function createFaq(
  dataRoomId: string,
  question: CreateFaqValues,
  relatedNodeId?: string,
) {
  return httpClient.post<Question>(`data-room-questions/faqs`, {
    ...question,
    dataRoomId,
    dataRoomNodeId: relatedNodeId,
  });
}

function updateFaq(
  faqId: string,
  dataRoomId: string,
  question: CreateFaqValues,
  relatedNodeId?: string,
) {
  return httpClient.patch<Question>(`data-room-questions/faqs/${faqId}`, {
    ...question,
    dataRoomId,
    dataRoomNodeId: relatedNodeId,
  });
}

function publishQestionToFaq(qId: string, values: FAQAccessInfo) {
  return httpClient.post<Question>(
    `data-room-questions/faqs/${qId}/publish`,
    values,
  );
}

function deleteQestionToFaq(qId: string) {
  return httpClient.delete(`data-room-questions/faqs/${qId}`);
}

function getFaqsAccessData(dataRoomId: string) {
  return httpClient.get<DataRoomFaqAccessGranularityData>(
    `data-room-questions/faqs/data-rooms/${dataRoomId}/granularity-metadata`,
  );
}

export default {
  getFaqs,
  createFaq,
  updateFaq,
  publishQestionToFaq,
  deleteQestionToFaq,
  getFaqsAccessData,
};
